import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { Icon, IconName } from 'react-frontier2';
import { useTitle } from '@arema/components/Hooks';
import classNames from 'classnames';
import NotFound from './NotFound';

interface SidebarRoute{
	url: string,
	title?: string,
	render?: JSX.Element
	component?: (...params: any)=>JSX.Element,
	params?: any,
}

interface SidebarItem{
	type?: 'item' | 'header'
	text: string,
	icon?: IconName,
	url?: string,
	target?: '_blank' | '_self' | '_parent' | '_top',
	if?: boolean,
	selectable?: boolean,
}

interface SidebarProps{
	breakpoint?: number,
	header?: string,
	routes: SidebarRoute[],
	items: SidebarItem[],
	routeParams?: any,
	emptyComponent?: JSX.Element,
	getTitle?: (r: SidebarRoute, ix: number)=>string,
	contentHeader?: JSX.Element,
}

var SidebarItemRender = (props: SidebarItem & { active: boolean })=>(
	props.if===false ? null : 
	props.type==='header' ? (
		<div className="divider">{props.text}</div>
	) : (
		<Link className={classNames('item', {
			active: props.active,
		})} replace={false} to={props.url} target={props.target || '_self'}>
			{!!props.icon && (
				<Icon name={props.icon} />
				// <i className={`${props.icon} icon`}></i>
			)}
			{props.text}
		</Link>
	)
)

var SidebarContainer = (props: SidebarProps)=>{
	const SIDEBAR_BREAKPOINT = props.breakpoint || 675;
	var location = useLocation();
	var [mobile, setMobile] = useState<boolean>(false);
	var [sectionIndex, setSectionIndex] = useState<number>(null);
	var [drawer, setDrawer] = useState<boolean>(false);
	var { setTitle } = useTitle();

	useEffect(()=>{
		var onResize = ()=>{
			if(!mobile && window.innerWidth<=SIDEBAR_BREAKPOINT){
				setMobile(true);
			}else if(mobile && window.innerWidth>SIDEBAR_BREAKPOINT){
				setMobile(false);
			}
		}
		window.addEventListener('resize', onResize);
		setMobile(window.innerWidth<=SIDEBAR_BREAKPOINT)
		
		var new_sect = getSectionFromUrl(location.pathname);
		var found_index = null;
		for(var i=0; i<props.routes.length; i++){
			var sect = getSectionFromUrl(props.routes[i].url)
			if(sect===new_sect){
				found_index = i;
				break;
			}
			if(!sect) continue;
			var sect_reg = new RegExp(sect.replace(/\:([a-z0-9_]+)/gi, (m, p)=>`([^\/]+)`) + '$', 'gi');
			if(sect_reg.test(new_sect)){
				found_index = i;
				break;
			}
		}

		
		if(sectionIndex!==found_index){
			setDrawer(false);
			setSectionIndex(found_index);
			if(found_index!==null && found_index>-1){
				if(props.getTitle){
					var title = props.getTitle(props.routes[found_index], found_index);
					if(title){
						setTitle(title);
					}
				}else if(props.routes[found_index].title){
					setTitle(props.routes[found_index].title);
				}
			}
		}
		return ()=>{
			window.removeEventListener('resize', onResize);
		}
	}, [mobile, location.pathname]);

	var getSectionFromUrl = (url: string)=>{
		return url;
		// var reg = new RegExp(props.locationRegexp);
		// var reg_res = reg.exec(url);
		// return reg_res && reg_res.groups.section && reg_res.groups.section.length>0 ? reg_res.groups.section : null;
	}

	var getParamsFromUrl = (template: string, url: string)=>{
		var reg = template.replace(/\:([a-z0-9_]+)/g, (m, p)=>`(?<${p}>[a-z0-9_]+)`);
		var reg_res = new RegExp(reg+'$', 'gi').exec(url);
		return reg_res?.groups || {}
	}

	var isItemActive = (url: string)=>{
		var current_section = getSectionFromUrl(location.pathname);
		var check_section = getSectionFromUrl(url);

		return current_section===check_section;
	}

	var toggleDrawer = ()=>{
		setDrawer(!drawer);
	}

	var Content: JSX.Element = null, content_params = {};
	if(sectionIndex!==null){
		if(props.routes[sectionIndex].render){
			Content = props.routes[sectionIndex].render;
		}else if(props.routes[sectionIndex].component){
			const ContentFn = props.routes[sectionIndex].component;
			const route_params = props.routes[sectionIndex].params;
			content_params = getParamsFromUrl(props.routes[sectionIndex].url, location.pathname);
			Content = <ContentFn params={content_params} {...route_params} {...props.routeParams} />
		}
	}
	
	return <div className={classNames('fr sidebar', {
		mobile,
		'drawer-active': drawer,
	})} style={{ marginTop: -10, minHeight: 'calc(100vh - 90px)' }}>
		{!mobile ? (
			<div className="sidebar">
				{!!props.header && (
					<div className="header item">{props.header}</div>
				)}
				{props.items.map((a, i)=>(
					<SidebarItemRender key={`SDBR-${a.url || a.text.replace(/ /g, '-')}`} active={a.selectable!==false && isItemActive(a.url)} {...a} />
				))}
			</div>
		) : (
			<div className={`drawer ${drawer ? 'active' : ''}`} style={{ top: 40 }}>
				<div className="header" onClick={toggleDrawer}>
					<div className="text">{props.header}</div>
					<i className="caret down icon"></i>
				</div>
				{props.items.map((a, i)=>(
					<SidebarItemRender key={`DRW-${a.url || a.text.replace(/ /g, '-')}`}  active={a.selectable!==false && isItemActive(a.url)} {...a} />
				))}
			</div>
		)}
		<div className="contents">
			{sectionIndex===null || Content===null ? (
				props.emptyComponent || <NotFound />
			) : <>
				{props.contentHeader}
				{Content}
			</>}
		</div>
		{drawer && (
			<div className="overlay" onClick={toggleDrawer}></div>
		)}
	</div>
}

export default SidebarContainer;